import { Swiper } from './swiper-YSyQLWy6.js';
import { A as A11y } from './a11y-crvyJz6s.js';
import { A as Autoplay } from './autoplay-BWI582TX.js';
import './utils-DfPPEfgu.js';
import './classes-to-selector-BKH7ThcP.js';

class AnnouncementBar extends HTMLElement {
  /** @type {import('swiper').Swiper | undefined} */
  #swiper;

  /** @type {ResizeObserver | undefined} */
  #resizeObserver;

  disconnectedCallback() {
    this.#swiper?.destroy(true, true);
    this.#swiper = undefined;
    this.#resizeObserver?.disconnect();
    window.removeEventListener('resize', this.#updateHeight);
    document.documentElement.style.setProperty('--announcement-bar-height', '0px');
  }

  #isSticky = () => {
    const isDesktop = window.matchMedia('(min-width: 64rem)').matches;

    return isDesktop
      ? this.hasAttribute('data-sticky-desktop')
      : this.hasAttribute('data-sticky-mobile');
  };

  #updateHeight = () => {
    const height = this.#isSticky() ? this.offsetHeight : 0;
    document.documentElement.style.setProperty('--announcement-bar-height', `${height}px`);
  };

  #setupHeightTracking() {
    const isSticky =
      this.hasAttribute('data-sticky-mobile') || this.hasAttribute('data-sticky-desktop');

    if (!isSticky || this.#resizeObserver) return;

    this.#updateHeight();
    this.#resizeObserver = new ResizeObserver(this.#updateHeight);
    this.#resizeObserver.observe(this);
    window.addEventListener('resize', this.#updateHeight, { passive: true });
  }

  connectedCallback() {
    this.#setupHeightTracking();

    const el = this.querySelector('.swiper');
    if (!el || el.classList.contains('swiper-initialized')) return;

    const count = Number(this.dataset.uspCount || 0);
    if (count === 0) return;

    const delay = Number(this.dataset.autoplayDelay || 5000);

    this.#swiper = new Swiper(el, {
      modules: [A11y, Autoplay],
      slidesPerView: 1,
      spaceBetween: 0,
      centerInsufficientSlides: true,
      centeredSlides: true,
      watchOverflow: true,
      autoplay:
        count > 1
          ? {
              delay,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }
          : false,
      rewind: count > 1,
      breakpoints: {
        768: {
          slidesPerView: count,
          spaceBetween: 20,
          centeredSlides: false,
          autoplay: false,
          rewind: false,
        },
      },
    });
  }
}

if (!customElements.get('announcement-bar')) {
  customElements.define('announcement-bar', AnnouncementBar);
}
